import { COVERGO_SAAS_DEV, COVERGO_ASIA_PRE_PROD } from "../consts.js"

export const asiaeb = {
	"asia-health-dev-studio.quote.hk": {
		appConfig: {
			tenantId: "asia_dev",
			appId: "admin_portal",
		},
		envConfig: COVERGO_SAAS_DEV,
	},
	"asia-studio.preprod.asia.covergo.cloud": {
		appConfig: {
			tenantId: "asia_preprod",
			appId: "admin_portal",
		},
		envConfig: COVERGO_ASIA_PRE_PROD,
	},
}
